
import {
  UPDATE_ORDER_ID_FROM_ORDER_PAGE_SUCCESS,
  EDIT_ORDER_FOR_ORDER_PAGE_SUCCESS,
  DELETE_ORDER_FOR_ORDER_PAGE_SUCCESS,
  GO_BUTTON_FOR_ORDER_PAGE_SUCCESS,
  SAVE_ORDER_FROM_ORDER_PAGE_SUCCESS,
  GET_ORDER_LIST_PAGE_SUCCESS,
  GET_ORDER_LIST_PAGE,
  ORDER_APPROVAL_ACTION_SUCCESS,
  GET_ORDER_APPROVAL_DETAIL_SUCCESS,
  UPDATE_ORDER_ID_FROM_ORDER_PAGE,
  SAVE_ORDER_FROM_ORDER_PAGE,
  GO_BUTTON_FOR_ORDER_PAGE,
  ORDER_APPROVAL_ACTION,
  GET_ORDER_APPROVAL_DETAIL,
  ORDER_API_ERROR_ACTION,
  POST_ORDER_CONFIRM_API_SUCCESS,
  POST_ORDER_CONFIRM_API,
  EDIT_ORDER_FOR_ORDER_PAGE,
  DELETE_ORDER_FOR_ORDER_PAGE,
  ORDER_SINGLE_GET_API_SUCCESS,
  ORDER_SINGLE_GET_API,
  ORDER_ITEMS,
  ORDER_ITEMS_SUCCESS,
  ADD_ORDER_ITEMS,
  ADD_ORDER_ITEMS_SUCCESS,
  LIST_BUTTON_LOADING_START,
  LIST_BUTTON_LOADING_END,
  MANUALLY_ORDER_CLOSE,
  MANUALLY_ORDER_CLOSE_SUCCESS,
  ORDER_ACCOUNTING_APPROVAL_SUCCESS,
  ORDER_ACCOUNTING_APPROVAL
} from "./actionType"


const INIT_STATE = {
  goBtnLoading: false,
  saveBtnloading: false,
  goBtnOrderAdd: null,
  OrderItems: [],
  OrderItemLoading: false,
  postMsg: { Status: false },
  editData: { Status: false, Items: [] },
  updateMsg: { Status: false },
  deleteMsg: { Status: false },
  orderList: [],
  orderApprovalMsg: { Status: false },
  approvalDetail: { Status: false },
  orderConfirmMsg: { Status: false },
  orderConfirmLoading: false,
  gotoInvoiceBtnLoading: false,
  listBtnLoading: false,
  orderData: { Status: false },
  AddOrderItems: [],
  AddOrderItemsLoading: false,
  Order_Close_Data: false,
  accountsApproveLoading: false,
  accountsApproveMsg: { Status: false },
}

const OrderReducer = (state = INIT_STATE, action) => {

  switch (action.type) {


    case GO_BUTTON_FOR_ORDER_PAGE:
      return {
        ...state,
        goBtnLoading: true,
      }

    case GO_BUTTON_FOR_ORDER_PAGE_SUCCESS:
      return {
        ...state,
        goBtnLoading: false,
        goBtnOrderAdd: action.payload,
      }



    case ORDER_ITEMS:
      return {
        ...state,
        OrderItemLoading: true,
      }

    case ORDER_ITEMS_SUCCESS:
      return {
        ...state,
        OrderItemLoading: false,
        OrderItems: action.payload,
      }

    case ADD_ORDER_ITEMS:

      return {
        ...state,
        AddOrderItemsLoading: true,
      }

    case ADD_ORDER_ITEMS_SUCCESS:
      return {
        ...state,
        AddOrderItemsLoading: false,
        AddOrderItems: action.payload,
      }

    case SAVE_ORDER_FROM_ORDER_PAGE:

      let { gotoInvoiceMode = false } = action.config
      return {
        ...state,
        saveBtnloading: !gotoInvoiceMode,
        gotoInvoiceBtnLoading: gotoInvoiceMode,
      }

    case SAVE_ORDER_FROM_ORDER_PAGE_SUCCESS:

      return {
        ...state,
        saveBtnloading: action?.payload?.saveBtnloading || false,
        gotoInvoiceBtnLoading: false,
        postMsg: action.payload,
      }

    case EDIT_ORDER_FOR_ORDER_PAGE:
      return {
        ...state,
        listBtnLoading: action.config.btnId,
      }

    case EDIT_ORDER_FOR_ORDER_PAGE_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        editData: action.payload,
      }

    case MANUALLY_ORDER_CLOSE:
      return {
        ...state,
        listBtnLoading: action.config.btnId,
      }

    case MANUALLY_ORDER_CLOSE_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        Order_Close_Data: action.payload,
      }

    case UPDATE_ORDER_ID_FROM_ORDER_PAGE:
      return {
        ...state,
        saveBtnloading: true,
      }

    case UPDATE_ORDER_ID_FROM_ORDER_PAGE_SUCCESS:
      return {
        ...state,
        saveBtnloading: false,
        updateMsg: action.payload,
      }

    case DELETE_ORDER_FOR_ORDER_PAGE:
      return {
        ...state,
        listBtnLoading: action.config.btnId,
      }
    case DELETE_ORDER_FOR_ORDER_PAGE_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        deleteMsg: action.payload,
      }


    case GET_ORDER_LIST_PAGE:
      return {
        ...state,
        goBtnLoading: true,
        listBtnLoading: true,
        orderList: [],
      }

    // Order List Page 
    case GET_ORDER_LIST_PAGE_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        goBtnLoading: false,
        orderList: action.payload,
      }

    case GET_ORDER_APPROVAL_DETAIL:
      return {
        ...state,
        listBtnLoading: action.config.btnId,
        saveBtnloading: true,
      }

    case GET_ORDER_APPROVAL_DETAIL_SUCCESS:
      return {
        ...state,
        approvalDetail: action.payload,
        listBtnLoading: false,
        saveBtnloading: false,
      }

    case ORDER_APPROVAL_ACTION:
      return {
        ...state,
        saveBtnloading: true,
        listBtnLoading: action.config.btnId,
      }
    case ORDER_APPROVAL_ACTION_SUCCESS:
      return {
        ...state,
        listBtnLoading: false,
        saveBtnloading: false,
        orderApprovalMsg: action.payload,
      }

    case POST_ORDER_CONFIRM_API:
      return {
        ...state,
        orderConfirmLoading: true,
        listBtnLoading: action.config.btnId,
      }

    case POST_ORDER_CONFIRM_API_SUCCESS:
      return {
        ...state,
        orderConfirmLoading: false,
        listBtnLoading: false,
        orderConfirmMsg: action.payload,
      }

    case ORDER_SINGLE_GET_API:
      return {
        ...state,
        listBtnLoading: action.config.btnId,

      }


    case ORDER_SINGLE_GET_API_SUCCESS:
      return {
        ...state,
        orderData: action.payload,
        listBtnLoading: false,
      }

    case ORDER_API_ERROR_ACTION:
      return {
        ...state,
        goBtnLoading: false,
        saveBtnloading: false,
        listBtnLoading: false,
        orderConfirmLoading: false,
        gotoInvoiceBtnLoading: false
      }
    case LIST_BUTTON_LOADING_START:
      return { ...state, listBtnLoading: action.config.btnId };

    case LIST_BUTTON_LOADING_END:
      return { ...state, listBtnLoading: false };

    case ORDER_ACCOUNTING_APPROVAL:
      return {
        ...state,
        accountsApproveLoading: true,
        listBtnLoading: action.config.btnId,
      }
    case ORDER_ACCOUNTING_APPROVAL_SUCCESS:
      return {
        ...state,
        accountsApproveLoading: false,
        listBtnLoading: false,
        accountsApproveMsg: action.payload,
      }


    default:
      return state
  }

}

export default OrderReducer